import { v4 as uuidv4 } from 'uuid';
import { AllBreakTypes } from '@sdk/settings/types';

import { BreakEntry } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';

type Payload = {
  timeClockEntryKey: string;
  type?: AllBreakTypes;
  replacesAttestedBreakNumber?: number;
};
export const getEmptyBreakEntry = ({
  timeClockEntryKey,
  type = AllBreakTypes.standard,
  replacesAttestedBreakNumber = undefined,
}: Payload): BreakEntry => ({
  key: uuidv4(),
  timeClockEntryKey,
  type,
  replacesAttestedBreakNumber,
  start: '',
  end: '',
});
